import { EmailsConfiguration } from '~/pages/Portal/Settings/EmailControls';
import api from '~/utils/api';

export async function getEmailConfigurationByType(
  tipoConfiguracao: number,
): Promise<EmailsConfiguration> {
  const { data } = await api.get<EmailsConfiguration>(
    `/configuracao_email/tipo_configuracao/`,
    { params: { tipo_configuracao: tipoConfiguracao } },
  );

  return data;
}
